import styled from '@emotion/styled';

export const StyledReportWrap = styled.div`
  margin-top: 15px;
`;

export const SettingWrapper = styled.div`
  display: flex;
  min-width: 1000px;
  align-items: center;
  background: #fff;
  padding: 20px 40px;
  /* padding: 47.65px 40px 46.35px; */
  margin-top: 10px;
  &:first-of-type {
    margin-top: 0;
  }
  & > strong {
    position: relative;
    display: block;
    width: 200px;
    height: 24px;
    font-size: 16px;
    line-height: 23px;
  }
`;
export const SettingBox = styled.div`
  position: relative;
  width: calc(100% - 232px);
  margin-left: 32px;
  padding-top: 10px;
  padding-bottom: 10px;

  &:before {
    content: '';
    display: block;
    width: 1px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: -32px;
    background: #e0e0e0;
  }

  & > :last-child {
    margin-bottom: 0;
  }
`;
export const SettingList = styled.ul`
  position: relative;
  margin-bottom: 30px;

  & > li {
    display: flex;
    white-space: nowrap;
    align-items: center;
    margin-top: 28px;
    font-size: 16px;
    color: #333;
    &:first-of-type {
      margin-top: 0;
    }
  }
  & .guide-text {
    margin-top: 10px;
    font-weight: 400;
    font-size: 12px;
    color: #fa8282;
  }
  & .selectbox-text {
    margin-left: 5px;
    color: #484848;
  }
`;
export const InputList = styled.ul`
  position: relative;
  display: flex;
  align-items: center;

  & span {
    font-weight: 400;
    font-size: 14px;
  }

  & li {
    margin-right: 36px;
  }
  & .sub-title {
    width: 150px;
  }
  & .send-off {
    margin-left: 5px;
  }
`;
export const SwButtonSection = styled.section`
  display: flex;
  justify-content: flex-end;
  margin-top: 53px;
  & button {
    margin-top: 0;
  }
`;
export const SelectBox = styled.div`
  min-width: 84px;
  font-size: 14px;
  x & div {
    border-radius: 4px;
  }
  & ol {
    & li {
      padding: 0 16px;
      justify-content: left;
    }
  }
`;

export const SwitchBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 180px;
  height: 36px;
  margin-top: -5px;
  margin-left: 10px;
  padding: 0;
  box-sizing: border-box;
  background-color: #effdda;

  & > span {
    position: relative;
    font-weight: bold;
    font-size: 14px;
    padding-left: 16px;
  }
`;

export const StyledImageSettingBox = styled.div`
  display: flex;
  &.none {
    & .overlay-box {
      background-color: #f3f3f3;
    }
  }
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  cursor: pointer;
`;

export const ReferenceBox = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 26px;
  font-size: 14px;

  .select-box {
    width: 210px;
    margin-left: 20px;
  }
`;
